import { motion } from "framer-motion";
import { useSearch } from "wouter";
import { useBookingContext } from "@/components/booking/getbookingContext";
import { BookingStep } from "@/components/booking/types";
import { PaymentModal } from "@/components/booking/PaymentModal";
import { BookingStatusModal } from "./BookingStatusModal";
import { BookingSuccess } from "./BookingSuccess";

/**
 * The payment / processing / success overlays that sit on top of the booking
 * screen. Reads everything it needs from BookingContext.
 */
export function BookingFlowModals() {
  const {
    bookingStep,
    reservationData,
    handlePaymentSuccess,
    handlePaymentCancel,
    handleSuccessDashboard,
    handleSuccessBookAnother,
  } = useBookingContext();
  // `?plan=` carries a choice made before the reservation existed — onboarding
  // hands off here for a single seat, which can only be paid for against one.
  const preselectedOptionId =
    new URLSearchParams(useSearch()).get("plan") || undefined;

  return (
    <>
      {/* Payment Modal */}
      {bookingStep === BookingStep.PAYMENT &&
        reservationData?.booking &&
        reservationData?.paymentOptions && (
          <PaymentModal
            bookingId={reservationData.booking.id}
            paymentOptions={reservationData.paymentOptions}
            preselectedOptionId={preselectedOptionId}
            startDate={reservationData.startDate}
            onSuccess={handlePaymentSuccess}
            onCancel={handlePaymentCancel}
          />
        )}
      {/* Polling Loading Modal */}
      {bookingStep === BookingStep.PROCESSING && <BookingStatusModal />}

      {/* Success Modal */}
      {bookingStep === BookingStep.SUCCESS && reservationData?.booking && (
        <div className="fixed inset-0 bg-black/60 flex overflow-hidden items-center justify-center z-50 p-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="card flex p-0 overflow-hidden max-w-4xl w-full my-8"
          >
            <BookingSuccess
              bookingData={{
                eventTimeId: reservationData.booking.eventTimeId,
                neighborhoodId: reservationData.booking.neighborhoodId,
              }}
              paymentAmount={0}
              paymentCurrency="usd"
              onViewDashboard={handleSuccessDashboard}
              onBookAnother={handleSuccessBookAnother}
            />
          </motion.div>
        </div>
      )}
    </>
  );
}
